import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Box, Drawer, List, ListItem, ListItemText, Toolbar } from '@mui/material';

import { useAuth } from '../context/AuthContext';
import { ADMIN_ROLE, ORG_MANAGER_ROLE } from '../context/AuthContext';

import PowerIcon from '@mui/icons-material/Power';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import BadgeIcon from '@mui/icons-material/Badge';

const drawerWidth = 240;

const data = [
  {
    label: 'Profile',
    icon: <PowerIcon sx={{ color: 'secondary.main' }} />,
    link: '/profile',
  },
]

const admin = [
  {
    label: 'Applications',
    icon: <PowerIcon sx={{ color: 'secondary.main' }} />,
    link: '/applications',
  },
  {
    label: 'RA Mapping',
    icon: <AltRouteIcon sx={{ color: 'secondary.main' }} />,
    link: '/ra',
  },
  {
    label: 'RA Profiles',
    icon: <BadgeIcon sx={{ color: 'secondary.main' }} />,
    link: '/ra-profiles',
  },
  {
    label: 'Consumptions',
    icon: <AccountTreeIcon sx={{ color: 'secondary.main' }} />,
    link: '/consumptions',
  },
  {
    label: 'Bussiness Relations',
    icon: <PeopleAltIcon sx={{ color: 'secondary.main' }} />,
    link: '/users',
  },
];

const orgManager = [
  {
    label: 'Bussiness Relations',
    icon: <PeopleAltIcon sx={{ color: 'secondary.main' }} />,
    link: '/users',
  },
];

// const superUserData = [...admin, ...orgManager];

const Sidebar = () => {
  const { logout, hasRole } = useAuth();
  const isAdmin = hasRole(ADMIN_ROLE);
  const isManager = hasRole(ORG_MANAGER_ROLE);
  return (
    <Box sx={{ display: 'flex' }}>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        <Box sx={{ display: 'flex', justifyContent: 'center', px: 2, pb: 1 }}>
          <Box
            component="img"
            src="/logotipo-uanataca-2.png"
            alt="Billing logo"
            sx={{ width: '100%', maxWidth: 170, height: 'auto' }}
          />
        </Box>
        <List>
          {data.map((item) => (
            <ListItem
              button
              component={Link}
              to={item.link}
              key={item.label}
              sx={{
                textDecoration: 'none',
                color: 'inherit', // Ensures the link color matches the theme
                '&:visited': {
                  color: 'inherit', // Prevents purple color for visited links
                },
              }}
            >
              {item.icon}
              <ListItemText primaryTypographyProps={{ fontWeight: 'bold' }} primary={item.label} />
            </ListItem>
          ))}
          {(isAdmin) && admin.map((item) => (
            <ListItem
              button
              component={Link}
              to={item.link}
              key={item.label}
              sx={{
                textDecoration: 'none',
                color: 'inherit', // Ensures the link color matches the theme
                '&:visited': {
                  color: 'inherit', // Prevents purple color for visited links
                },
              }}
            >
              {item.icon}
              <ListItemText primaryTypographyProps={{ fontWeight: 'bold' }} primary={item.label} />
            </ListItem>
          ))}
          {(isManager && !isAdmin) && orgManager.map((item) => (
            <ListItem
              button
              component={Link}
              to={item.link}
              key={item.label}
              sx={{
                textDecoration: 'none',
                color: 'inherit', // Ensures the link color matches the theme
                '&:visited': {
                  color: 'inherit', // Prevents purple color for visited links
                },
              }}
            >
              {item.icon}
              <ListItemText primaryTypographyProps={{ fontWeight: 'bold' }} primary={item.label} />
            </ListItem>
          ))}
          {/* Logout button */}
          <ListItem button onClick={logout}>
            <ListItemText primaryTypographyProps={{ fontWeight: 'bold' }} primary="Logout" />
          </ListItem>
        </List>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};

export default Sidebar;
